import React, {useEffect, useRef, useState} from 'react'
import './DesignExterno.css'
import Logo from '../../media/logos/PNG/ISO_FELES_Supervisor.png'
import LogoGray from '../../media/felsv/LogoItprofes-gray.svg'
import '../../text-responsive.css'

const DesignExterno = (props: any) => {
  const [centrar, setCentrar] = useState(false)
  const right = useRef<HTMLDivElement>(null)
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  useEffect(() => {
    if (right?.current && right.current.scrollHeight > right.current.clientHeight) setCentrar(true)

    window.addEventListener('resize', handleResize, false)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (centrar && right?.current && right.current.scrollHeight > right.current.clientHeight)
      setCentrar(false)
    else if (right?.current && right.current.scrollHeight <= right.current.clientHeight)
      setCentrar(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions.height])

  useEffect(() => {
    if (centrar && right?.current && right.current.scrollHeight > right.current.clientHeight)
      setCentrar(false)
    else if (right?.current && right.current.scrollHeight <= right.current.clientHeight)
      setCentrar(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.children])

  return (
    <main>
      <div className='body-externo'>
        <div className='body-externo-lateral-left'>
          <div className='card-externo-logo'>
            <img src={Logo} alt='ItProfis' style={{width: '30px', height: '35px'}} />
          </div>
          <div className='body-externo-lateral-title xl'>{props.title}</div>
        </div>
        <div
            className={`body-externo-lateral-right${
            centrar ? ' body-externo-lateral-right-center' : ''
          }`}
          ref={right}
        >
          {props.children}
        </div>
      </div>
      <footer className='body-externo-footer'>
        <div className='externo-footer-copyright'>
          © FEL APP. 2023. Todos los derechos reservados.
        </div>
        <div className='externo-footer-desarrollado'>
          <div>Desarrollado por&nbsp;&nbsp;</div>
          <img src={LogoGray} alt='ItProfis' />
        </div>
      </footer>
    </main>
  )
}

export default DesignExterno
